/* global axios */
import ApiClient from './ApiClient';

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getAccountReports(metric, since, until) {
    return axios.get(`${this.url}/account`, {
      params: { metric, since, until },
    });
  }

  getAccountSummary(since, until) {
    return axios.get(`${this.url}/account_summary`, {
      params: { since, until },
    });
  }

  getAgentReports(since, until) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until },
    });
  }
  getConversationReports(since, until, inbox_id) {
    return axios.get(`${this.url}/conversations`, {
      params: { since, until, inbox_id},
    });
  }
}

export default new ReportsAPI();
